import { render, staticRenderFns } from "./signpod.vue?vue&type=template&id=2cf574ed&scoped=true"
import script from "./signpod.vue?vue&type=script&lang=js"
export * from "./signpod.vue?vue&type=script&lang=js"
import style0 from "./signpod.vue?vue&type=style&index=0&id=2cf574ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf574ed",
  null
  
)

export default component.exports